module.exports = __webpack_public_path__ + "img/t4-endorsement-list.632c75d7.png";